import React, { Fragment } from 'react';
import './Styles.css';

const Radio = (props) => {
    return <Fragment>
        <div className="radioBox" >
            <input type="radio" id={props.id} value={props.value} checked={props.checked} name={props.name} onChange={(e) => props.onChange(e)}/>
            <label htmlFor={props.id}>{props.label}</label>
        </div>
    </Fragment>
}
export default Radio;

